<template>
  <div class="tab">
    <router-link
      class="tab-item"
      v-for="tab in tabs"
      :key="tab.path"
      :to="tab.path"
    >
      <img :src="$route.path.includes(tab.path) ? tab.activeIcon : tab.icon" alt="">
    </router-link>
  </div>

</template>

<script>
import recordNormal from '@/assets/images/tab_record_normal.png'
import recordSelected from '@/assets/images/tab_record_selected.png'
import homeNormal from '@/assets/images/tab_home_normal.png'
import homeSelected from '@/assets/images/tab_home_selected.png'
import meNormal from '@/assets/images/tab_me_normal.png'
import meSelected from '@/assets/images/tab_me_selected.png'
  export default {
    name: 'tab',
    computed: {
      tabs () {
        return [
          {
            name: this.$t('tab.record'),
            path: '/record',
            activeIcon: recordSelected,
            icon: recordNormal
          },
          {
            name: this.$t('tab.home'),
            path: '/home',
            activeIcon: homeSelected,
            icon: homeNormal
          },
          {
            name: this.$t('tab.mine'),
            path: '/mine',
            activeIcon: meSelected,
            icon: meNormal
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tab {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: var(--tab-height);

    z-index: 100;
    display: flex;
    background-color: $color-background;
    border-top: 1px solid rgba(255, 255, 255, 0.2);

    /* 适配 iPhone 底部黑条 */
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    .tab-item {
      flex: 1;
      display: flex;
      justify-content: center; /* 水平居中：左右居中 */
      align-items: center;     /* 垂直居中：上下居中 */

      img {
        width: 28px;
        height: 28px;
        display: block;
      }
    }
  }
</style>
